import React, { useState, useCallback, useEffect } from 'react';
import useApi from '../../api/useApi';

function CreateEvent({ handleClose, notification, selectedEventId, deviceTypes }) {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const { userId } = JSON.parse(sessionStorage.user).user;

  const formModel = {
    name: '',
    scope: [],
    attributes: { subScope: '', deviceType: [], enableRecipients: true },
    status: 'CREATED',
    isActive: true,
    createdBy: userId,
  };

  const [formData, setFormData] = useState(formModel);

  const [{ isLoading, isError, data }, createEvent] = useApi();
  const [eventRes, getEvent] = useApi();
  const [updateRes, updateData] = useApi();

  useEffect(() => {
    if (selectedEventId) {
      getEvent(`/events/${selectedEventId}`, 'GET');
    } else {
      setFormData({ ...formModel });
    }
  }, [selectedEventId]);

  useEffect(() => {
    if (!eventRes.isLoading && !eventRes.isError && eventRes.data) {
      if (eventRes.data.status === 'SUCCESS') {
        setFormData({
          ...eventRes.data.event,
          attributes: { ...formData.attributes, ...eventRes.data.event.attributes },
        });
      }
    }
    if (eventRes.isError) {
      notification('error', 'Unable to fetch Event detail');
    }
  }, [eventRes]);

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const attributes = formData.attributes;
    if (!formData.scope.includes('DEVICE')) {
      delete attributes.deviceType;
    }
    if (!attributes.subScope) {
      delete attributes.subScope;
    }
    const body = {
      ...formData,
      name: formData.name?.trim().replaceAll(' ', '_').toUpperCase(),
      attributes,
    };

    if (!selectedEventId) {
      createEvent('/events', 'POST', body);
    } else {
      updateData(`/events/${selectedEventId}`, 'PATCH', body);
    }
  };

  useEffect(() => {
    if (updateRes.data !== null) {
      notification('success', 'Event details updated successfully');
      handleClose(true);
    }
    if (updateRes.isError) {
      notification('error', 'Unable to update Event details');
    }
  }, [updateRes]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setFormData({ ...formModel });
      notification('success', 'Event Created Successfully');
      handleClose(true);
    }

    if (isError) {
      notification('error', 'Unable to create Event');
    }
  }, [isLoading, isError, data]);

  const handleSelectScope = (e) => {
    if (e.target.value)
      setFormData({
        ...formData,
        scope: [...formData.scope, e.target.value],
      });
  };

  const deleteScope = (item) => {
    const scopes = formData.scope.filter((x) => x !== item);
    setFormData({ ...formData, scope: scopes });
  };

  const handleSelectDevice = (e) => {
    if (e.target.value)
      setFormData({
        ...formData,
        attributes: {
          ...formData.attributes,
          deviceType: [...formData.attributes.deviceType, e.target.value],
        },
      });
  };

  const deleteDevice = (item) => {
    const devices = formData.attributes.deviceType.filter((x) => x !== item);
    setFormData({ ...formData, attributes: { ...formData.attributes, deviceType: devices } });
  };

  return (
    <div
      className="flex justify-center items-center h-full w-full z-20 fixed"
      style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))', overflowY: 'scroll' }}
    >
      <div className={`bg-white w-full sm:w-2/4 relative top-${!selectedEventId ? 0 : 8} rounded-2xl pb-3`}>
        <div className="flex justify-between items-center border-b px-6 py-4">
          <p className="font-bold text-sm text-textBlue1">{!selectedEventId ? 'New' : 'Edit'} Event</p>
          <img src="assets/img/Close.svg" className="h-3 cursor-pointer" alt="" onClick={() => handleClose(false)} />
        </div>

        {eventRes?.isLoading ? (
          <div className="flex text-xs my-10">
            <img src="assets/img/loader.svg" className="w-12 mx-auto" alt="" />
          </div>
        ) : (
          <form className="px-5" onSubmit={handleSubmit}>
            <div className="mt-2 grid grid-cols-2 gap-x-10">
              <div className="mt-4 w-full relative">
                <input
                  placeholder="Name"
                  type="text"
                  value={formData.name}
                  disabled={!!selectedEventId}
                  name="name"
                  className="inputLabelText px-4 py-2 focus:outline-none"
                  onChange={handleInputChange}
                />
              </div>

              <div className="mt-4 w-full">
                <select
                  placeholder="Scope"
                  type="text"
                  name="scope"
                  // value={formData.scope}
                  className="inputLabelText w-full px-4 py-2 focus:outline-none text-black font-normal"
                  onChange={handleSelectScope}
                >
                  <option value="">Select Scope</option>
                  {['ORGANIZATION', 'WAREHOUSE', 'ZONE', 'DEVICE'].map((item) => (
                    <option key={item}>{item}</option>
                  ))}
                </select>

                <div className="w-full flex flex-wrap gap-x-3 mt-2">
                  {formData.scope.map((x) => (
                    <div
                      key={x}
                      className="flex gap-x-2 text-black py-1 px-2 text-xs mt-2 rounded-full border cursor-pointer justify-between items-center"
                    >
                      <p onClick={() => deleteScope(x)}>{x}</p>
                      <img
                        src="assets/img/Close.svg"
                        className="h-2 cursor-pointer "
                        alt=""
                        onClick={() => deleteScope(x)}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-4 w-full">
                <select
                  placeholder="Sub Scope"
                  type="text"
                  name="SubScope"
                  value={formData.attributes?.subScope}
                  className="inputLabelText w-full px-4 py-2 focus:outline-none text-black font-normal"
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      attributes: { ...formData.attributes, subScope: e.target.value },
                    });
                  }}
                >
                  <option value="">Select SubScope</option>
                  {['PROJECT'].map((item) => (
                    <option key={item}>{item}</option>
                  ))}
                </select>
              </div>

              <div className="mt-8 ml-2 w-full gap-x-3 flex justify-start items-center">
                <input
                  type="checkbox"
                  name="enableRecipients"
                  className="h-4 w-4"
                  checked={formData?.attributes?.enableRecipients}
                  onChange={() => {
                    setFormData({
                      ...formData,
                      attributes: { ...formData.attributes, enableRecipients: !formData?.attributes?.enableRecipients },
                    });
                  }}
                />
                <label>Enable Recipients</label>
              </div>

              {formData.scope.includes('DEVICE') && (
                <div className="mt-4 w-full">
                  <select
                    placeholder="Device Type"
                    type="text"
                    name="deviceType"
                    className="inputLabelText px-4 py-2 focus:outline-none text-black font-normal"
                    onChange={handleSelectDevice}
                  >
                    <option value="">Select Device Type</option>
                    {deviceTypes.map((deviceType) => (
                      <option key={deviceType?.slug} value={deviceType?.slug}>
                        {deviceType?.displayName}
                      </option>
                    ))}
                  </select>

                  <div className="w-full flex flex-wrap gap-x-3 mt-2">
                    {formData?.attributes?.deviceType?.map((x) => (
                      <div
                        key={x}
                        className="flex gap-x-2 text-black py-1 px-2 text-xs mt-2 rounded-full border cursor-pointer justify-between items-center"
                      >
                        <p onClick={() => deleteDevice(x)}>{x}</p>
                        <img
                          src="assets/img/Close.svg"
                          className="h-2 cursor-pointer "
                          alt=""
                          onClick={() => deleteDevice(x)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="mb-2 mt-6">
              {updateRes.isLoading || isLoading ? (
                <div className="flex text-xs">
                  <img src="assets/img/loader.svg" className="w-12 ml-auto" alt="" />
                </div>
              ) : (
                <div className="flex text-xs gap-x-3 justify-end">
                  <button
                    onClick={() => handleClose()}
                    className="rounded-3xl border focus:outline-none w-28 py-2 cursor-pointer "
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="rounded-3xl focus:outline-none w-28 py-2 text-white bg-btnBg cursor-pointer "
                    style={{ border: '1px solid #16406D' }}
                  >
                    Save
                  </button>
                </div>
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default CreateEvent;
